import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowsAltV,
  faCoffee,
  faInfoCircle,
  faTimes,
  faArrowUp,
  faUserSecret
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faArrowsAltV,
  faCoffee,
  faInfoCircle,
  faTimes,
  faArrowUp,
  faUserSecret
)
